module.exports = __webpack_public_path__ + "e46710f62818374d7a1af9845a5d5c66.svg";